<template>
	<div>
		<transition>
			<b-container fluid>
				<b-row align-h="center" class="mb-3 mt-3">
					<!-- <h2 class="textBlue">
						{{ $t("login.login") }}
					</h2> -->
				</b-row>

				<b-form @submit.stop.prevent="onSubmit">
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="melli_code_group"
								:label="$t('login.melliCode')"
								label-for="melli_code"
							>
								<b-form-input
									id="melli_code"
									type="number"
									v-model="$v.form.melli_code.$model"
									:state="validateState('melli_code')"
								>
								</b-form-input>
								<b-form-invalid-feedback id="melli_code-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="melli_code-live-feedback"
									v-show="!$v.form.melli_code.checkMelliCode"
								>
									{{ $t("validation.MelliCodeCheck") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="password_group"
								:label="$t('login.password')"
								label-for="password"
								class="marginclass"
							>
								<b-form-input
									id="password"
									type="password"
									v-model="$v.form.password.$model"
									aria-describedby="password-live-feedback"
									:state="validateState('password')"
								></b-form-input>
								<b-form-invalid-feedback id="password-live-feedback">
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>

								
							</b-form-group>
						</b-col>
					</b-row>

					<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div>
								<b-button
									type="submit"
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary"
									>{{ $t("login.login") }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-form>
				<b-row align-h="center" class="mb-5 pb-5">
					
					<b-col md="8" cols="9">
						<hr />
						<small>
						<b-link to="/new-forgat-page" class="text-color--400">
							{{ $t("login.forgotPassword") }}</b-link
						>
						</small>
						<small class="text-color--400  ml-2">
							
							<b-link to="/newregister"> {{ $t("login.signUp") }}</b-link>
						</small>
					</b-col></b-row
				>
			</b-container>
		</transition>
	</div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";



import { required } from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	data() {
		return {
			form: {
				melli_code: "",
				password: "",
			},
		};
	},
	validations: {
		form: {
			melli_code: {
				required,
				checkMelliCode(code) {
					if (
						!/^\d{10}$/.test(code) ||
						code == "0000000000" ||
						code == "1111111111" ||
						code == "2222222222" ||
						code == "3333333333" ||
						code == "4444444444" ||
						code == "5555555555" ||
						code == "6666666666" ||
						code == "7777777777" ||
						code == "8888888888" ||
						code == "9999999999"
					)
						return false;
					var check = parseInt(code[9]);
					var sum = 0;
					var i;
					for (i = 0; i < 9; ++i) {
						sum += parseInt(code[i]) * (10 - i);
					}
					sum %= 11;
					return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
				},
			},
			password: { required },
		},
	},
	methods: {
		onSubmit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				console.log(this.$v.form);
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				let load = this.$loading.show();
				this.$store
					.dispatch("login", this.form)
					.then((response) => {
						console.log(response);
						load.hide();

						//this.$router.push({ name: "registerPage" });
						this.$router.push({ path: "/customer/IdentityInfo" });
					})
					.catch((err) => {
						console.log(err);
						this.$noty.error(err.body.detail);
						load.hide();
					});
			}
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},
	},
};
</script>

<style scoped>
.btn-left {
	display: block;
	margin-right: auto;
}
.marginclass {
	margin-top: -1.6rem;
}
</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css">

</style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.csss"></style>
